import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ExternalLinkIcon } from 'lucide-react';
interface Booklet {
  id: number;
  title: string;
  category: string;
  description: string;
  cover_image: string;
  drive_url: string;
}

/* =========================
   DATA BOOKLET
========================= */
const booklets: Booklet[] = [{
  id: 1,
  title: 'Meneladani Sikap Positif dari Ayah dan Ibu',
  category: 'Sosial',
  description: 'Menjadikan sikap baik orang tua sebagai contoh dalam membangun hubungan yang hangat.',
  cover_image: 'https://yrcfwfrejpzvafteucff.supabase.co/storage/v1/object/public/assets/Hlm%201.png',
  drive_url: 'https://drive.google.com/file/d/1OadyDSecpfBddkkj2tdyHPIgEW3MpCZl/view'
}, {
  id: 2,
  title: 'Menghargai Perbedaan dan Membangun Kerja Sama',
  category: 'Belajar',
  description: 'Mengembangkan sikap saling menghargai agar tercipta kerja sama.',
  cover_image: 'https://yrcfwfrejpzvafteucff.supabase.co/storage/v1/object/public/assets/Hlm%201%20belajar.png',
  drive_url: 'https://drive.google.com/file/d/1i2lOkKBhtvK-1niKA2NUyiTfoT8JVMN2/view'
}, {
  id: 3,
  title: 'Etika Sosial untuk Masa Depan',
  category: 'Karier',
  description: 'Membiasakan perilaku disiplin dan tanggung jawab.',
  cover_image: 'https://yrcfwfrejpzvafteucff.supabase.co/storage/v1/object/public/assets/Hlm%20karir.png',
  drive_url: 'https://drive.google.com/file/d/1HdEXH4alx_t1yYriY1pUJc1w1aBORYaE/view'
}, {
  id: 4,
  title: 'Menerima Diri',
  category: 'Pribadi',
  description: 'Belajar memahami kelebihan diri dan menghargai perbedaan.',
  cover_image: 'https://yrcfwfrejpzvafteucff.supabase.co/storage/v1/object/public/assets/Hlm%201%20Pribadi.png',
  drive_url: 'https://drive.google.com/file/d/1Xx9_cb8FtzJhk5Ewb1WGVPCbOhixFo5T/view'
}];

/* =========================
   DATA POSTER
========================= */
const posters = [{
  id: 1,
  cover_image: 'https://yrcfwfrejpzvafteucff.supabase.co/storage/v1/object/public/assets/Poster%20Bidang%20Sosial.png'
}, {
  id: 2,
  cover_image: 'https://yrcfwfrejpzvafteucff.supabase.co/storage/v1/object/public/assets/Poster%20Bidang%20Belajar.png'
}, {
  id: 3,
  cover_image: 'https://yrcfwfrejpzvafteucff.supabase.co/storage/v1/object/public/assets/Poster%20Bidang%20Karier.png'
}, {
  id: 4,
  cover_image: 'https://yrcfwfrejpzvafteucff.supabase.co/storage/v1/object/public/assets/Poster%20Bidang%20Pribadi.png'
}];
/* =========================
   DATA BANNER & SPANDUK
========================= */
const banners = [{
  id: 1,
  cover_image: 'https://yrcfwfrejpzvafteucff.supabase.co/storage/v1/object/public/assets/X%20Banner%20Bidang%20Sosial.png'
}, {
  id: 2,
  cover_image: 'https://yrcfwfrejpzvafteucff.supabase.co/storage/v1/object/public/assets/X%20Banner%20Bidang%20Belajar.png'
}, {
  id: 3,
  cover_image: 'https://yrcfwfrejpzvafteucff.supabase.co/storage/v1/object/public/assets/X%20Banner%20Bidang%20Karier.png'
}, {
  id: 4,
  cover_image: 'https://yrcfwfrejpzvafteucff.supabase.co/storage/v1/object/public/assets/X%20Banner%20Bidang%20Pribadi.png'
}];
const spanduk = [{
  id: 5,
  cover_image: 'https://yrcfwfrejpzvafteucff.supabase.co/storage/v1/object/public/assets/Spanduk%20Bidang%20Sosial.png'
}, {
  id: 6,
  cover_image: 'https://yrcfwfrejpzvafteucff.supabase.co/storage/v1/object/public/assets/Spanduk%20Bidang%20Belajar.png'
}, {
  id: 7,
  cover_image: 'https://yrcfwfrejpzvafteucff.supabase.co/storage/v1/object/public/assets/Spanduk%20Bidang%20Karier.png'
}, {
  id: 8,
  cover_image: 'https://yrcfwfrejpzvafteucff.supabase.co/storage/v1/object/public/assets/Spanduk%20Bidang%20Pribadi.png'
}];
export function Edukasi() {
  const [selected, setSelected] = useState<Booklet | null>(null);
  const [selectedPoster, setSelectedPoster] = useState<string | null>(null);
  return <div className="min-h-screen bg-white py-12" data-id="element-239">
      <div className="max-w-6xl mx-auto px-4" data-id="element-240">

        {/* HEADER */}
        <div className="text-center mb-16" data-id="element-241">
          <h1 className="text-4xl font-bold text-dark mb-4" data-id="element-242">
            Layanan Edukasi
          </h1>
          <p className="text-gray-600" data-id="element-243">
            Booklet dan poster edukasi digital
          </p>
        </div>

        {/* ================= BOOKLET ================= */}
        <h2 className="text-2xl font-bold mb-6 text-center" data-id="element-244">
          Booklet Edukasi
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-6xl mx-auto" data-id="element-245">
          {booklets.map((book, index) => <motion.div key={book.id} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-3xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-246">
              <div className="aspect-[3/4]" data-id="element-247">
                <img src={book.cover_image} className="w-full h-full object-cover" data-id="element-248" />
              </div>

              <div className="p-5" data-id="element-249">
                <span className="text-xs text-gray-500" data-id="element-250">
                  {book.category}
                </span>

                <h3 className="text-lg font-bold mt-2 mb-2" data-id="element-251">
                  {book.title}
                </h3>

                <p className="text-sm text-gray-600 mb-4" data-id="element-252">
                  {book.description}
                </p>

                <button onClick={() => setSelected(book)} className="text-blue-600 font-medium text-sm" data-id="element-253">
                  Lihat Detail →
                </button>
              </div>
            </motion.div>)}
        </div>

        {/* ================= POSTER ================= */}
        <div className="mt-20" data-id="element-254">
          <h2 className="text-2xl font-bold mb-8 text-center" data-id="element-255">
            Poster Edukasi
          </h2>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-5xl mx-auto" data-id="element-256">
            {posters.map((poster, index) => <motion.div key={poster.id} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} onClick={() => setSelectedPoster(poster.cover_image)} className="cursor-pointer rounded-2xl overflow-hidden border border-gray-200 shadow-sm hover:shadow-xl hover:scale-105 transition-all duration-300" data-id="element-257">
                <img src={poster.cover_image} className="w-full h-auto object-contain bg-white" data-id="element-258" />
              </motion.div>)}
          </div>
        </div>
        {/* ================= BANNER & SPANDUK ================= */}
<div className="mt-20" data-id="element-259">
  <h2 className="text-2xl font-bold mb-8 text-center" data-id="element-260">
    Banner Edukasi
  </h2>

  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto" data-id="element-261">
    {banners.map((banner, index) => <motion.div key={banner.id} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} onClick={() => setSelectedPoster(banner.cover_image)} className="cursor-pointer rounded-2xl overflow-hidden border border-gray-200 shadow-sm hover:shadow-xl hover:scale-105 transition-all duration-300" data-id="element-262">
        <img src={banner.cover_image} className="w-full h-auto object-contain bg-white" data-id="element-263" />
      </motion.div>)}
  </div>
</div>
{/* ================= SPANDUK ================= */}
<div className="mt-20" data-id="element-264">
  <h2 className="text-2xl font-bold mb-8 text-center" data-id="element-265">
    Spanduk Edukasi
  </h2>

  <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-6xl mx-auto" data-id="element-266">
    {spanduk.map((item, index) => <motion.div key={item.id} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} onClick={() => setSelectedPoster(item.cover_image)} className="cursor-pointer rounded-2xl overflow-hidden border border-gray-200 shadow-sm hover:shadow-xl hover:scale-105 transition" data-id="element-267">
        <img src={item.cover_image} className="w-full h-auto object-contain bg-white" data-id="element-268" />
      </motion.div>)}
  </div>
</div>

        {/* ================= MODAL BOOKLET ================= */}
        {selected && <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50" data-id="element-269">
            <div className="bg-white rounded-2xl max-w-lg w-full p-6" data-id="element-270">

              <img src={selected.cover_image} className="w-full h-64 object-cover rounded-xl mb-4" data-id="element-271" />

              <h2 className="text-xl font-bold mb-2" data-id="element-272">
                {selected.title}
              </h2>

              <p className="text-gray-600 mb-4" data-id="element-273">
                {selected.description}
              </p>

              <a href={selected.drive_url} target="_blank" className="inline-flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg" data-id="element-274">
                Selengkapnya
                <ExternalLinkIcon size={16} data-id="element-275" />
              </a>

              <button onClick={() => setSelected(null)} className="ml-3 text-gray-500" data-id="element-276">
                Tutup
              </button>
            </div>
          </div>}

        {/* ================= MODAL POSTER (FULLSCREEN) ================= */}
        {selectedPoster && <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4" onClick={() => setSelectedPoster(null)} data-id="element-277">
            <img src={selectedPoster} className="max-h-full max-w-full object-contain rounded-xl" data-id="element-278" />
          </div>}

      </div>
    </div>;
}